import { useMutation } from 'react-query';
import { getClientSecretId, updateLeadOutcome } from '../services/payment';

export const useGetClientSecretId = () => {
  return useMutation(getClientSecretId);
};

export const useUpdateLeadOutcome = () => useMutation(updateLeadOutcome);
